const CACHE_PREFIX = "penner_mgmt:";
const DEFAULT_TTL_MS = 10 * 60 * 1000;

const stableSerialize = (value) => {
  if (value == null || typeof value !== "object") {
    return String(value);
  }
  if (Array.isArray(value)) {
    return `[${value.map(stableSerialize).join(",")}]`;
  }
  const entries = Object.keys(value)
    .sort()
    .map((key) => `${key}=${stableSerialize(value[key])}`);
  return `{${entries.join(",")}}`;
};

export const buildPennerCacheKey = (resource, params = {}) =>
  `${CACHE_PREFIX}${resource}:${stableSerialize(params)}`;

export const getPennerCache = (key, ttlMs = DEFAULT_TTL_MS) => {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const { data, ts } = JSON.parse(raw);
    if (Date.now() - ts > ttlMs) {
      localStorage.removeItem(key);
      return null;
    }
    return data;
  } catch {
    return null;
  }
};

export const setPennerCache = (key, data) => {
  try {
    localStorage.setItem(key, JSON.stringify({ data, ts: Date.now() }));
  } catch {
    // ignore quota errors
  }
};

export const removePennerCache = (key) => {
  try {
    localStorage.removeItem(key);
  } catch {
    // ignore
  }
};

export const clearPennerCache = () => {
  try {
    Object.keys(localStorage)
      .filter((key) => key.startsWith(CACHE_PREFIX))
      .forEach((key) => localStorage.removeItem(key));
  } catch {
    // ignore
  }
};
